import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../theme/ThemeContext';

interface ThemeToggleProps {
  // Set when the toggle sits on the navy header/inverse surface
  onInverse?: boolean;
  className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ onInverse = false, className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const label = theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode';

  return (
    <button
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      className={`w-11 h-11 inline-flex items-center justify-center rounded-sm border transition-colors ${
        onInverse
          ? 'border-white/20 text-slate-300 hover:text-white hover:bg-white/10'
          : 'border-line-strong text-ink-muted hover:text-ink hover:bg-raised'
      } ${className}`}
    >
      {theme === 'light' ? <Moon size={18} /> : <Sun size={18} />}
    </button>
  );
};
